import { requireUser } from './permissions';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import ForcePassChange from './pages/ForcePassChange';
import ResetPass from './pages/ResetPass';
import ResetPassEmail from './pages/ResetPassEmail';
import Demo from './pages/Demo';
import Logout from './pages/Logout';

export const appRoutes = [
  {
    name: 'login',
    path: '/login',
    comp: Login,
  },
  // TODO: Unflatten routes, nest under shared namespace
  {
    name: 'forcePasswordChange',
    path: '/change',
    comp: ForcePassChange,
  },
  {
    name: 'reset',
    path: '/reset-password',
    comp: ResetPassEmail,
  },
  {
    name: "resetPassword",
    path: "/reset-password/:code",
    comp: ResetPass,
  },
  {
    name: 'demo',
    path: '/demo',
    comp: Demo,
  },
  {
    name: 'logout',
    path: '/logout',
    comp: Logout,
  },
  {
    name: 'index',
    path: '/',
    comp: Home,
    canActivate: requireUser(),
  }
];
